export default "__VITE_ASSET__0y5soa42__"